export default __webpack_public_path__ + "static/media/349.b911e60e.gif";